var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTileBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 471,
    viewBox: "0 0 333 471",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.5 216C228.632 216 279 165.632 279 103.5C279 101.318 278.938 99.151 278.815 97H301C318.673 97 333 111.327 333 129V439C333 456.673 318.673 471 301 471H32C14.3269 471 0 456.673 0 439V129C0 111.327 14.3269 97 32 97H54.1846C54.0621 99.151 54 101.318 54 103.5C54 165.632 104.368 216 166.5 216Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 166.5,
    cy: 103.5,
    r: 103.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileBg);
export default __webpack_public_path__ + "static/media/tile_bg.4bf7a26c144eb50d23c6255b60c3dff7.svg";
export { ForwardRef as ReactComponent };